import {
  ConectoresClientes,
  ConectoresConfiguracoes,
  ConectoresConfiguracaoCadastro,
  ConectoresConfiguracaoInformacoes,
} from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/conectores/configuracoes',
    parent: '/conectores',
    text: 'Configurações',
    match: /\/conectores\/configuracoes+$/,
    sider: true,
    component: ConectoresClientes,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/configuracoes/:idCliente',
    text: 'Clientes',
    component: ConectoresConfiguracoes,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/configuracao/:id',
    text: 'Conector',
    exact: true,
    component: ConectoresConfiguracaoCadastro,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/conectores/configuracao/:idCliente/:id/informacoes',
    text: 'Conector',
    exact: true,
    component: ConectoresConfiguracaoInformacoes,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
